import React, { useState } from 'react';
import { LifeBuoy, AlertCircle, HelpCircle } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { ReportIssueModal } from './ReportIssueModal';
import { HelpFAQModal } from './HelpFAQModal';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-sonner-toast';
import { useReportingMode } from '@/contexts/ReportingModeContext';

export function HelpMenu() {
  const [isReportIssueModalOpen, setIsReportIssueModalOpen] = useState(false);
  const [isHelpFAQModalOpen, setIsHelpFAQModalOpen] = useState(false);
  const { currentUser } = useAuth();
  const { toast } = useToast();
  const { isReportingMode, setIsReportingMode } = useReportingMode();

  const handleReportElement = () => {
    if (!currentUser) {
      toast({
        title: 'Sign in required',
        description: 'You need to be signed in to report elements.',
        variant: 'destructive',
      });
      return;
    }

    // Check if we're in the forge by looking for the Elements & Discoveries panel
    const isInForge = document.querySelector('.elements-panel') !== null;

    if (!isInForge) {
      toast({
        title: 'Feature Unavailable',
        description:
          'Element reporting is only available in the forge. Please enter the forge first.',
        variant: 'destructive',
      });
      return;
    }

    // Activate reporting mode using the context
    setIsReportingMode(true);

    toast({
      title: 'Element Reporting Mode Activated',
      description: 'Click on any element in the Elements & Discoveries panel to report it.',
      variant: 'default',
    });
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="relative">
            <LifeBuoy className="h-5 w-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setIsReportIssueModalOpen(true)}>
            <AlertCircle className="mr-2 h-4 w-4" />
            <span>Report an Issue</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleReportElement}>
            <AlertCircle className="mr-2 h-4 w-4" />
            <span>Report an Element</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setIsHelpFAQModalOpen(true)}>
            <HelpCircle className="mr-2 h-4 w-4" />
            <span>Help & FAQ</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ReportIssueModal
        isOpen={isReportIssueModalOpen}
        onClose={() => setIsReportIssueModalOpen(false)}
      />

      <HelpFAQModal isOpen={isHelpFAQModalOpen} onClose={() => setIsHelpFAQModalOpen(false)} />
    </>
  );
}
